import { API } from "src/api/request";

export async function getWokerLimit(params) {
  const response = await API().get("/product/limit/worker", {
    params: { ...params },
  });
  return response.data;
}

export async function getListWoker(params) {
  const response = await API().get("/product/worker", {
    params: { ...params },
  });
  return response.data;
}
export async function getListWokerOut(params) {
  const response = await API().get("/product/worker_out", {
    params: { ...params },
  });
  return response.data;
}

export async function postListWokerOut_post(params) {
  const response = await API().post("/product/worker_out/worker", {
    ...params,
  });
  return response.data;
}
export async function getListWokerOut_worker(params) {
  const response = await API().get("/product/worker_out/worker", {
    params: { ...params },
  });
  return response.data;
}

export async function getListNotWoker(params) {
  const response = await API().get("product/not/worker", {
    params: { ...params },
  });
  return response.data;
}
export async function postListWoker(params) {
  const response = await API().post("/product/worker", { ...params });
  return response.data;
}
export async function editListWoker(id, params) {
  const response = await API().post("/product/plan/" + id, { ...params });
  return response.data;
}
export async function deleteWorker(params) {
  const response = await API().delete("/product/worker", {
    params: { ...params },
  });
  return response.data;
}
export async function getPlanList(params) {
  const response = await API().get("/product/plan", {
    params: { ...params },
  });
  return response.data;
}

export async function postPlan(params) {
  const response = await API().post("/product/plan", { ...params });
  return response.data;
}

export async function getPlanDetail(id) {
  const response = await API().get("/product/plan/" + id);
  return response.data;
}

export async function deletePlan(params) {
  const response = await API().delete("/product/plan/", {
    params: { ...params },
  });
  return response.data;
}

export async function getNorm(params) {
  const response = await API().get("/product/plan/worker", {
    params: { ...params },
  });
  return response.data;
}

export async function getNormOut(params) {
  const response = await API().get("/product/plan/workerout", {
    params: { ...params },
  });
  return response.data;
}

export async function postNorm(params) {
  const response = await API().post("/product/plan/worker", { ...params });
  return response.data;
}
export async function postNormOut(params) {
  const response = await API().post("/product/plan/workerout", { ...params });
  return response.data;
}
export async function deleteNorm(params) {
  const response = await API().delete("/product/plan/worker", {
    params: { ...params },
  });
  return response.data;
}
export async function getRegisterList(params) {
  const response = await API().get("/product/register", {
    params: { ...params },
  });
  return response.data;
}
export async function getRegisterTn(params) {
  const response = await API().get("/product/register/worker", {
    params: { ...params },
  });
  return response.data;
}
export async function getWorkerPlan(params) {
  const response = await API().get("/product/register/worker/plan", {
    params: { ...params },
  });
  return response.data;
}
export async function getProductCount(params) {
  const response = await API().get("/product/report/product/month", {
    params: { ...params },
  });
  return response.data;
}
export async function getWorkerInfo(tn) {
  const response = await API().get("/worker/" + tn);
  return response.data;
}
export async function postRegister(params) {
  const response = await API().post("/product/register/worker", { ...params });
  return response.data;
}
export async function putRegister(params) {
  const response = await API().put("/product/register/worker", { ...params });
  return response.data;
}
export async function deleteRegister(params) {
  const response = await API().delete("/product/register", { ...params });
  return response.data;
}
export async function getReport(params) {
  const response = await API().get("product/report/product/month", {
    params: { ...params },
  });
  return response.data;
}
export async function getRegisterReportList(params) {
  const response = await API().get("/product/report/register/month", {
    params: { ...params },
  });
  return response.data;
}
export async function getProduct(params) {
  const response = await API().get("/product");
  return response.data;
}

export async function getControlList(params) {
  const response = await API().get("/product/limit", { params: { ...params } });
  return response.data;
}
export async function postControlPost(params) {
  const response = await API().post("/product/limit/worker", { ...params });
  return response.data;
}
